import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { dateFormatter, DateFormatTypes, formatDate, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (result: any) => {
  const response = isSuccessResponse(result)
  return {
    ...response,
    data: response?.data?.map((item: any) => {
      return {
        ...item,
        actionAt: formatDate(item?.actionAt),
        createdDate: formatDate(item?.createdDate),
        lastModifiedDate: formatDate(item?.lastModifiedDate),
      }
    }),
  }
}

export const getFileType = (approvalDataType: string) => {
  if (
    approvalDataType === 'PACKAGE_CONFIG_1' ||
    approvalDataType === 'MID_PACKAGE_CONFIG_1' ||
    approvalDataType === 'PACKAGE_CONFIG_0' ||
    approvalDataType === 'MID_PACKAGE_CONFIG_0'
  ) {
    return {
      fileType: approvalDataType === 'PACKAGE_CONFIG_1' || approvalDataType === 'MID_PACKAGE_CONFIG_1' ? '1' : '0',
    }
  }
}

export const getApprovalDataType = (approvalDataType: string) => {
  if (approvalDataType === 'PACKAGE_CONFIG_0' || approvalDataType === 'PACKAGE_CONFIG_1') {
    return 'PACKAGE_CONFIG'
  } else if (approvalDataType === 'MID_PACKAGE_CONFIG_1' || approvalDataType === 'MID_PACKAGE_CONFIG_0') {
    return 'MID_PACKAGE_CONFIG'
  } else {
    return approvalDataType
  }
}

const getAuditTrialList = (
  username: string,
  approvalDataType: string,
  page: any,
  isAccessConfigPriviledged: boolean,
  userType: string,
  tokens: any,
  abortController: any,
) => {
  console.log('getAuditTrialList userType: ', userType)
  const request: JFSRequest<{}> = {
    apiPath: `${getUrl(APIEndPoints.auditTrialList)}?type=${userType}`,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens, abortController),
    headers: getHeaders(),
    body: {
      filter: {
        ...(!isAccessConfigPriviledged && username?.length > 0 && { username: username }),
        // ...(approvalType?.length > 0 && { approvalType: approvalType }),
        ...(approvalDataType?.length > 0 && {
          approvalDataType: getApprovalDataType(approvalDataType),
        }),
        // ...(approvalAction?.length > 0 && { approvalAction: approvalAction }),
        // ...(actionBy?.length > 0 && { actionBy: actionBy }),
        ...getFileType(approvalDataType),
        fromDate: `${dateFormatter(RootStore?.selectedDateInfo?.fromDate, DateFormatTypes.YYYYMMDD)}00:00:00`,
        toDate: `${dateFormatter(RootStore?.selectedDateInfo?.toDate, DateFormatTypes.YYYYMMDD)}23:59:59`,
      },
      page,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAuditTrialList }
